import {Grid} from "@mui/material";
import React from "react";

export const DataGridContainer = (props) => {
    return <Grid container spacing={0} sx={{ p: 2, height: "100%" }}>{props.children}</Grid>;
}
